import { FunctionComponent } from 'preact';
import { useState } from 'preact/hooks';
import { usePopper } from 'react-popper';

const Warnings: FunctionComponent<WarningsProp> = ({ warnings }) => {
    const [ referenceElem, setReferenceElem ] = useState<HTMLButtonElement|null>(null);
    const [ popperElem, setPopperElem ] = useState<HTMLSpanElement|null>(null);
    const [ arrowElem, setArrowElem ] = useState<HTMLDivElement|null>(null);
    const { styles, attributes, update } = usePopper(referenceElem, popperElem, {
        placement: 'top',
        modifiers: [
            { name: 'arrow', options: { element: arrowElem }},
            { name: 'offset', options: { offset: [ 0, 8 ] }},
        ],
    });

    const onEnter = () => {
        popperElem?.setAttribute('data-show', '');
        if (update !== null) {
            update();
        }
    };

    const onLeave = () => {
        popperElem?.removeAttribute('data-show');
        if (update !== null) {
            update();
        }
    };

    if (!warnings) {
        return null;
    }

    return <>
        <div class="header__basket-summary_warning">
            <button
                ref={setReferenceElem}
                type="button"
                class="header__basket-summary_warning-icon"
                onMouseEnter={onEnter}
                onMouseLeave={onLeave}
                onFocus={onEnter}
                onBlur={onLeave}
            />
            <span class="d-inline d-sm-none d-xl-inline">Some items don't meet minimums or incur surcharges</span>
        </div>

        <div className="d-none d-sm-block d-xl-none">
            <span ref={setPopperElem} className="js-tooltip" id="js-header__basket-summary_warning" role="tooltip" style={styles.popper} {...attributes.popper}>
                Some items don't meet minimums or incur surcharges
                <div ref={setArrowElem} style={styles.arrow} className="js-arrow"></div>
            </span>
        </div>
    </>;
}

interface WarningsProp {
    warnings: boolean;
}

export default Warnings;
